import styled from "styled-components";

export const OptInLogoDefaultBox = styled.div`  
    width: 200px;
    height: 96px;
    background-size: 100%;
    background-image: url(${props => props.theme.assets.images.jackpot_bet.jackpot_bet_logo_png.toString()});


`;
